module.exports = __webpack_public_path__ + "static/img/2.950d8e55.jpg";